<div class="translation-update-confirmation">
  <h2 class="dialog-title">
    {{ 'DO_YOU_WANT_TO_UPDATE_TRANSLATE' | translate }}?
  </h2>

  <div class="translation">
    <div class="translation-filed">
      <div class="translation-filed-key">
        {{ 'TRANSLATION_KEY' | translate }}:
      </div>
      <div class="translation-filed-value">
        {{ data.translation.key }}
      </div>
    </div>

    <div class="translation-filed">
      <div class="translation-filed-key">
        {{ 'TRANSLATION_NEW_VALUE' | translate }}:
      </div>
      <div class="translation-filed-value">
        {{ data.translation.value }}
      </div>
    </div>

    <div class="translation-filed" *ngIf="canRestoreToDefault">
      <div class="translation-filed-key">
        {{ 'TRANSLATION_DEFAULT_VALUE' | translate }}
      </div>
      <div class="translation-filed-value">
        {{
          defaultTranslations[data.translation.key] || this.data.defaultValue
        }}
      </div>
    </div>
  </div>

  <div class="actions">
    <button
      [disabled]="isLoading"
      class="button is-info"
      (click)="updateTranslation()"
    >
      {{ 'UPDATE' | translate }}
    </button>

    <button
      [disabled]="isLoading"
      class="button is-danger"
      (click)="resetToDefault()"
      *ngIf="canRestoreToDefault"
    >
      {{ 'RESTORE_DEFAULT' | translate }}
    </button>

    <button [disabled]="isLoading" class="button cancel" (click)="cancel()">
      {{ 'CANCEL' | translate }}
    </button>
  </div>
</div>
